import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// import { requestForToken, onMessageListener } from "./services/firebase";
import appInfo from "./app-info";
import routes from "./app-routes";

import { SideNavInnerToolbar as SideNavBarLayout } from "./layouts";
import AnnouncementService from "./services/announcement";
// import { requestForToken, onMessageListener } from "./services/firebase";
// import { isSupported } from "firebase/messaging";

export default function Content() {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const { showNotification } = AnnouncementService();

  useEffect(() => {
    if (notification?.title) {
      showNotification({
        message: notification?.body,
        title: notification?.title,
      });
    }
  }, [notification]);

  // useEffect(() => {
  //   if (isSupported()) {
  //     requestForToken();
  //     getMessaging();
  //   }
  // }, []);

  // // requestForToken();
  // const getMessaging = () => {
  //   onMessageListener()
  //     .then((payload) => {
  //       setNotification({
  //         title: payload?.notification?.title,
  //         body: payload?.notification?.body,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log("🚀 ~ file: Content.js:43 ~ getMessaging ~ err:", err)
        
  //     });
  // };

  return (
    <SideNavBarLayout logo={appInfo.logo} logoDark={appInfo.logoDark}>
      <Switch>
        {routes.map(({ path, component }) => {
          return <Route exact key={path} path={path} component={component} />;
        })}
        <Redirect to={"/home"} />
      </Switch>
    </SideNavBarLayout>
  );
}
